












































































































import { Component, Watch, Prop } from 'vue-property-decorator'
import ViewBase from '@/util/ViewBase'
import { ListType } from '@/util/types'
import { courseItem, resourceItem } from '@/api/res'
import {
  TestingPointPic,
  TestingPointDes,
  TestRate,
  ClassUseTime,
  ClassAttempt,
  PersonalAttempt,
  PersonalUseTime,
  PersonalPoint
} from '@/components/studyData'
import { parse } from 'qs'
import { post, get } from '@/fn/ajax'
import { Tooltip, Modal, message } from 'ant-design-vue'

const echarts = require('echarts/lib/echarts')
// 引入柱状图组件
require('echarts/lib/chart/bar')
// 引入饼状图组件
require('echarts/lib/chart/pie')
// 引入提示框和title组件
require('echarts/lib/component/tooltip')
require('echarts/lib/component/title')
require('echarts/lib/component/legend')

@Component({
  components: {
    TestingPointPic,
    TestingPointDes,
    TestRate,
    ClassUseTime,
    ClassAttempt,
    PersonalAttempt,
    PersonalUseTime,
    PersonalPoint
  }
})
export default class StudyHistoryData extends ViewBase {
  lang: any = {}

  doc: any

  choseStudent: any = '0'

  ratingList: any = null

  pointsProcess: any = null

  pointsUseTime: any = null

  pointsTryCount: any = null

  steps: any = null

  points: any = null

  stepsEntirety: any = null

  loading: boolean = true

  level: string = ''

  process: any = null

  personalUseTime: any = null

  personalAttempt: any = null

  reviewInfo: any = null

  clientList: any = null

  onceInt: boolean = true

  get i18n() {
    const value = this.$t('login')
    return value as any
  }

  get isEnLang() {
    return this.$i18n.locale == 'en'
  }

  onStudentChange(value: any) {
    this.choseStudent = value
    const params: any = {}
    if (value != 0) {
      params.cid = value
      this.fetchStudent(params)
    } else {
      this.fetch()
    }
  }

  async fetchStudent(params: any = {}) {
    params.reviewId = this.$route.params.id
    try {
      this.loading = true
      const res = await post('/api/cate/clientReviewInfo', params)
      if (res && res.data) {
        const data = res.data
        // this.ratingList = data.ratingList
        // this.pointsProcess = data.pointsProcess
        this.level = data.level
        this.personalUseTime = data.pointsUseTime
        this.personalAttempt = data.pointsCount
        this.process = data.process
        this.steps = data.steps
        this.points = data.points
        this.loading = false
        this.onceInt = false
        // console.log(data)
      }
    } catch (ex) {
      message.error(String(ex))
    }
  }

  goBack() {
    this.$router.go(-1)
  }

  async fetch(params: any = {}) {
    this.loading = true
    params.reviewId = this.$route.params.id
    try {
      const res = await post('/api/cate/reviewInfo', params)
      if (res && res.data) {
        const data = res.data
        this.ratingList = data.ratingList
        this.pointsProcess = data.pointsProcess
        this.pointsUseTime = data.pointsUseTime
        this.pointsTryCount = data.pointsTryCount
        this.steps = data.steps
        this.points = data.points
        this.stepsEntirety = data.stepsEntirety
        this.reviewInfo = data.reviewInfo
        this.clientList = data.clientList
        this.loading = false
        this.onceInt = false
        // console.log(data)
      }
    } catch (ex) {
      message.error(String(ex))
    }
  }

  created() {
    this.doc = window.document
    this.lang = this.i18n.vStudy
    this.fetch()
  }
}
